export const userActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  LOG_OUT: 'LOG_OUT',
  SET_DB_TOKEN: 'SET_DB_TOKEN',
};
